@if(wizardStore.H().form; as formGroup){
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-validated-textarea
      [label]="translationKey + 'additionalCosts'"
      inputFormControlName="additionalCosts"
      [inputFormControl]="formGroup.controls.additionalCosts"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'furtherInformation'"
      inputFormControlName="furtherInformation"
      [inputFormControl]="formGroup.controls.furtherInformation"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'howToComplain'"
      inputFormControlName="howToComplain"
      [inputFormControl]="formGroup.controls.howToComplain"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'exitOptions'"
      inputFormControlName="exitOptions"
      [inputFormControl]="formGroup.controls.exitOptions"
      [rows]="10"
      [maxLength]="2000"
    />
  </app-card>
</form>

}
